export default __webpack_public_path__ + "static/media/loading.e63aacb6.png";